import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _objectSpread from "F:/openy-admin-all/openy-wxms-web2026-09-01/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:/openy-admin-all/openy-wxms-web2026-09-01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getNoticeNum, volunterRole, isSF, getStatList } from '@/api/mini';
import { platformSet, platformThridSet } from '@/api/login';
import { removeToken } from '@/utils/auth';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      // versionsIcon: 0,
      readNum: 0,
      backlogNum: 0,
      notifyNoticeCount: "",
      weappTodoNum: "",
      cServerNum: "",
      isShow: false,
      isBackShow: false,
      platform: {},
      isSf: 0,
      statList: [],
      showHelpDownList: false
    };
  },
  // watch: {
  //   roles(val) {
  //     console.log(val)
  //     this.versionsIcon = val.indexOf('all:manage');
  //   }
  // },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.getVolunterRole();
              this.getIsSf();
              this.showNoticeNum();

              if (this.versionsIcon != -1) {
                this.getStatListFn();
              }

              if (!localStorage.getItem("platform")) {
                this.getPlatfrom();
              } else {
                this.platform = JSON.parse(localStorage.getItem('platform'));
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  computed: _objectSpread(_objectSpread({}, mapGetters(['user', 'roles'])), {}, {
    informNum: function informNum() {
      return this.readNum + this.backlogNum + this.notifyNoticeCount + this.weappTodoNum;
    },
    isShowFn: function isShowFn() {
      if (this.$route.path == '/mini/message' || this.$route.path == '/mini/custom-website') {
        return 1;
      } else if (this.$route.meta.isNoShowLogo) {
        return 3;
      } else {
        return 2;
      }
    },
    appName: function appName() {
      return this.$store.state.mini.applyMessage.appName;
    },
    versionsIcon: function versionsIcon() {
      return this.$store.state.user.roles.indexOf('all:manage');
    }
  }),
  methods: {
    getIsSf: function () {
      var _getIsSf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return isSF();

              case 2:
                res = _context2.sent;

                if (!(res.code != '000000')) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (res.datas) {
                  this.isSf = res.datas.isSf;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getIsSf() {
        return _getIsSf.apply(this, arguments);
      }

      return getIsSf;
    }(),
    getVolunterRole: function () {
      var _getVolunterRole = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, arr;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return volunterRole();

              case 2:
                res = _context3.sent;

                if (!(res.code != '000000')) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                if (res.datas) {
                  arr = [];

                  if (res.datas.isVolPlatformManager) {
                    arr.push(1);
                  }

                  if (res.datas.isVolRegulatorManager) {
                    arr.push(2);
                  }

                  this.$store.commit('SET_VOLUNTEER', arr);
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getVolunterRole() {
        return _getVolunterRole.apply(this, arguments);
      }

      return getVolunterRole;
    }(),
    getStatListFn: function () {
      var _getStatListFn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getStatList(0);

              case 2:
                res = _context4.sent;

                if (!(res.code != '000000')) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                if (res.datas) {
                  this.statList = res.datas;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getStatListFn() {
        return _getStatListFn.apply(this, arguments);
      }

      return getStatListFn;
    }(),

    /**
     * 跳转到志愿列表
     */
    handleClickOpenVolunteer: function handleClickOpenVolunteer() {
      if (this.$store.state.user.volunteer.includes(1)) {
        var url = this.$router.resolve({
          path: '/volunteer'
        });
      } else {
        var url = this.$router.resolve({
          path: '/active'
        });
      }

      window.open(url.href, '_blank');
    },
    // 判断是否显示志愿服务入口
    volunteerRole: function volunteerRole() {
      return this.$store.state.user.volunteer.length > 0 ? true : false;
    },
    getPlatfrom: function () {
      var _getPlatfrom = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                res = '';

                if (!sessionStorage.getItem('platformType')) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 4;
                return platformThridSet(sessionStorage.getItem('platformType'));

              case 4:
                res = _context5.sent;
                _context5.next = 10;
                break;

              case 7:
                _context5.next = 9;
                return platformSet();

              case 9:
                res = _context5.sent;

              case 10:
                if (!(res.code != '000000')) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt("return");

              case 12:
                if (res.datas) {
                  localStorage.setItem("platform", JSON.stringify(res.datas));
                  this.platform = res.datas;
                }

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getPlatfrom() {
        return _getPlatfrom.apply(this, arguments);
      }

      return getPlatfrom;
    }(),
    handleCommandStatistics: function handleCommandStatistics(item) {
      var url = this.$router.resolve({
        path: '/statistics?id=' + item
      });
      window.open(url.href, '_blank');
    },
    handleClickGotoNotice: function handleClickGotoNotice(key) {
      this.$router.push("/notice/index?key=" + key);
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    handleClickLoginOut: function handleClickLoginOut() {
      var _this = this;

      this.$confirm('确定退出系统吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        removeToken();

        _this.$router.push('/');
      }).catch(function () {});
    },

    /**
     * 跳转到通知中心页
     */
    jumpNotice: function jumpNotice() {
      window.open("/notice/index");
    },
    jumpService: function jumpService() {
      window.open("/service/index");
    },
    jumpCustomerService: function jumpCustomerService() {
      window.open("/customer-service/index");
    },

    /**
     * 跳转到待办事项
     */
    jumpBacklog: function jumpBacklog() {
      if (this.$route.query.id) {
        window.open("/backlog/index?id=".concat(this.$route.query.id));
      } else {
        window.open("/backlog/index");
      }
    },
    handleClickGoto: function handleClickGoto(command) {
      if (command == 'a') {
        window.open(process.env.VUE_APP_BASE_API2 + "/u/detail/".concat(this.user.id));
      }

      if (command == 'c') {
        window.open("/accountSet");
      }
    },

    /**
     * 跳转到版本管理
     */
    toVersion: function toVersion() {
      this.$router.push({
        path: '/weapps/version'
      });
    },
    goToHelp: function goToHelp() {
      if (this.isSf == 1) {
        window.open("/help?outhelp=1");
      } else {
        window.open("/help");
      }
    },

    /**
     * 读取通知数
     */
    showNoticeNum: function () {
      var _showNoticeNum = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var data, readNum, backlogNum;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return getNoticeNum();

              case 2:
                data = _context6.sent;
                readNum = parseInt(data.datas.unReadNum);
                backlogNum = parseInt(data.datas.todoNum);
                this.readNum = readNum;
                this.backlogNum = backlogNum;
                this.notifyNoticeCount = data.datas.notifyNoticeCount * 1;
                this.weappTodoNum = parseInt(data.datas.weappTodoNum);
                this.cServerNum = parseInt(data.datas.msgUnReadNum);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function showNoticeNum() {
        return _showNoticeNum.apply(this, arguments);
      }

      return showNoticeNum;
    }(),

    /**
     * 显示帮助列表
     */
    onOffHelpDownList: function onOffHelpDownList() {
      this.showHelpDownList = !this.showHelpDownList;
    }
  }
};